<template>
  <v-container fluid>
    <v-dialog v-model="showDialog" width="800px">
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDialog = false"> Fechar </v-btn>
        </v-card-actions>
        <v-card-title>
          <span class="headline">Usuário</span>
        </v-card-title>

        <v-card-text>
          <v-form @submit.prevent="submit" ref="form" v-model="valid">
            <v-row class="ma-4">
              <v-col>
                <v-text-field
                  label="Nome"
                  v-model="userEdit.name"
                  :rules="nameRules"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-4">
              <v-col>
                <v-text-field
                  label="Email"
                  v-model="userEdit.email"
                  :disabled="userEdit.uid !== ''"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-4">
              <v-col>
                <v-text-field
                  label="Telefone"
                  v-model="userEdit.phone"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="ma-4">
              <v-col>
                <v-select
                  v-model="userEdit.enterprise"
                  :items="optionsEnterprises"
                  item-text="text"
                  item-value="value"
                  label="Empresa"
                  dense
                >
                </v-select>
              </v-col>
            </v-row>

            <v-row class="ma-4">
              <v-col>
                <v-text-field
                  v-if="userEdit.uid == ''"
                  v-model="userEdit.password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Senha"
                  hint="Pelo menos 6 caracteres"
                  counter
                  @click:append="show1 = !show1"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn class="secondary" @click="showDialog = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="save(userEdit)">
            <v-progress-circular
              v-show="saving"
              indeterminate
              color="white"
            ></v-progress-circular>
            <span v-show="!saving"> Salvar</span></v-btn
          >
        </v-card-actions>

        <v-card-text> </v-card-text>
      </v-card>
    </v-dialog>

    <v-row class="ma-4">
      <div class="text-h3" :class="`blue-grey--text text--darken-2`" color="">
        Usuários
      </div>
      <v-spacer></v-spacer>
      <v-btn class="primary" v-if="!loading" @click="newUser"> +Novo </v-btn>
    </v-row>

    <v-progress-circular
      v-show="loading"
      indeterminate
      color="primary"
    ></v-progress-circular>

    <v-card v-if="!loading">
      <v-toolbar color="primary" dark>
        <v-spacer></v-spacer>
        <v-toolbar-title style="color: white; font-weight: bold">
          Usuários
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-simple-table class="ma-4">
          <template v-slot:default>
            <thead>
              <tr>
                <th style="width: 100px">Delete</th>
                <th style="width: 300px" class="text-left">Nome</th>
                <th class="text-left">Email</th>
                <th class="text-left">Empresa</th>
                <th class="">Editar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in users" :key="item.id">
                <td class="text-left">
                  <!-- <v-btn @click="editUser(item, index)" class="secondary">
                    <v-icon>mdi-pencil-outline</v-icon></v-btn
                  > -->
                </td>
                <td>{{ item.name }}</td>
                <td>{{ item.email }}</td>

                <td v-if="item.enterprise">{{ item.enterprise.name }}</td>
                 <td class="text-left">
                  <v-btn @click="editUser(item, index)" class="secondary">
                    <v-icon>mdi-pencil-outline</v-icon></v-btn
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import hebelApi from '../../../../libraries/hebel/hebelApi';
export default {
  name: "Users",
  data() {
    return {
      users: [],
      enterprises: [],
      loading: true,
      showDialog: false,
      showDialog2: false,
      saving: false,
      show1: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 6 || "Min 6 characters",
        emailMatch: () => `The email and password you entered don't match`,
      },
      userEdit: {
        name: "",
        email: "",
        enterpriseId: "",
        password: "",
        phone: "",
        enterprise: {},
      },
      valid: true,

      nameRules: [(v) => !!v || "Nome é obrigatório"],
      emailRules: [
        (v) => !!v || "E-mail é obrigatório",
        (v) => /.+@.+/.test(v) || "E-mail precisa ser válido",
      ],
    };
  },
  async mounted() {
    //this.enterprises = await this.$dao.getEnterprises();
    this.enterprises = await hebelApi.enterprises.getAll();

    //this.users = await this.$dao.getUsers();
    this.users = await hebelApi.users.getAll();


    // this.users.sort(function (a, b) {
    //   return a.enterprise.name - b.enterprise.name;
    // });
    //alert("mounted")
    this.users.sort(function (a, b) {
      if (a.enterprise.name < b.enterprise.name) return -1;
      if (a.enterprise.name > b.enterprise.name) return 1;
      return 0;
    });
    //alert("sorted")

    this.loading = false;
  },

  computed: {
    optionsEnterprises: function () {
      var options = [];
      if (this.enterprises) {
        for (var e = 0; e < this.enterprises.length; e++)
          options.push({
            value: this.enterprises[e],
            text: this.enterprises[e].name,
          });
      }
      return options;
    },
  },

  methods: {
    submit() {
      this.$refs.observer.validate();
      alert("Submit");
    },
    // async saveEditingUser(user) {
    //   user.enterpriseId = user.enterprise.id;
    //   var ans = await this.dao.saveUser(user);
    //   for (var u = 0; u < this.users.length; u++) {
    //     if (this.users[u].uid == user.uid) this.users[u] = user;
    //   }
    //   this.$forceUpdate();
    //   this.showDialog = false;
    // },

    async save(user) {
      if (!this.valid) {
        this.$refs.form.validate();

        return;
      }

      this.saving = true;
      if (user.uid) {
        await this.saveEditingUser(user);
      } else {
        await this.addUser(user);
      }
      this.saving = false;
      this.showDialog = false;

      this.$forceUpdate();
    },
    async saveEditingUser(user) {
      user.enterpriseId = user.enterprise.id;
      //var ans = await this.$dao.saveUser(user);
      var ans = await hebelApi.users.patch(user);

      var index;
      for (var u = 0; u < this.users.length; u++) {
        if (this.users[u].uid == user.uid) index = u;
      }
      this.users.splice(index, 1);
      this.users.unshift(user);
    },

    validate() {
      this.$refs.form.validate();
      this.$forceUpdate();
      alert(this.valid);
      this.saving = false;
    },
    newUser() {
      this.userEdit = {
        uid: "",
        name: "",
        email: "",
        enterpriseId: "",
        password: "",
        phone: "",
        enterprise: {},
      };
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.showDialog = true;
    },

    async addUser(user) {
      //this.loadingCreation = true;
      this.saving = true;
      console.log("addUser");
      user.enterpriseId = user.enterprise.id;
      console.log("addUser" + JSON.stringify(user));
      //var c = await this.$dao.createUser(user);
      var c = await hebelApi.users.post(user);
      this.users.push(user);
    },
    editUser(user) {
      this.userEdit = Object.assign({}, user);
      this.showDialog = true;
    },
  },
};
</script>

<style scoped>
</style>